export { default as Field } from './Field.vue'
export { default as View } from './View.vue'
export const Icon = 'list_alt'
